import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { reaction } from 'mobx';
import { RendleyStore } from '../../../../store/RendleyStore';
import LibrettoClip from '../LibrettoClip/LibrettoClip';

interface LibrettoImageClipProps {
    librettoClipId: string;
    layerId: string;
    clipIds: string[];
}

export const LibrettoImageClip: React.FC<LibrettoImageClipProps> = observer(({ librettoClipId, clipIds, layerId }) => {
    const [filename, setFilename] = useState<string | undefined>();
    const [thumbnail, setThumbnail] = useState<string | undefined>();

    console.log("Rendering image clip with librettoClip: ", librettoClipId);

    useEffect(() => {
        const disposer = reaction(
            () => {
                const librettoClipState = RendleyStore.getLibrettoClipState(librettoClipId);
                return librettoClipState;
            },
            (librettoClipState) => {
                if (!librettoClipState.combinedProperties) {
                    console.log(`[LibrettoImageClip] No combined properties yet for ${librettoClipId}`);
                    setFilename(undefined);
                    setThumbnail(undefined);
                    return;
                }

                const { clipIds, combinedProperties } = librettoClipState;
                const firstClipId = combinedProperties.firstClipId;

                // ✅ ADD THIS: Check if the actual clip data exists in store
                const firstClip = RendleyStore.clips[firstClipId];
                if (!firstClip) {
                    console.log(`[LibrettoImageClip] Clip ${firstClipId} not in store yet, waiting...`);
                    setFilename("Loading...");
                    setThumbnail(undefined);
                    return;
                }

                setFilename(RendleyStore.getFilenameByClipId(firstClipId));
                setThumbnail(RendleyStore.getThumbnailByClipId(firstClipId));
            },
            { fireImmediately: true }
        );

        return () => { disposer(); };
    }, [librettoClipId, clipIds]);

    return (
        <LibrettoClip librettoClipId={librettoClipId} layerId={layerId} filename={filename} thumbnail={thumbnail} backgroundColor={"0, 228, 132"}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.5 1.5H2.5C1.94772 1.5 1.5 1.94772 1.5 2.5V9.5C1.5 10.0523 1.94772 10.5 2.5 10.5H9.5C10.0523 10.5 10.5 10.0523 10.5 9.5V2.5C10.5 1.94772 10.0523 1.5 9.5 1.5Z"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.25 5C4.66421 5 5 4.66421 5 4.25C5 3.83579 4.66421 3.5 4.25 3.5C3.83579 3.5 3.5 3.83579 3.5 4.25C3.5 4.66421 3.83579 5 4.25 5Z"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 7.5L8 5L2.5 10.5"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </LibrettoClip>
    );
});

export default LibrettoImageClip;
